import { createAsyncThunk } from "@reduxjs/toolkit";

import { editNestedIterableItem } from "core/iterable_utils";
import { changeFiltredRowData as changeFiltredRowDataKats } from "slices/kats";
import { changeRowData as changeRowDataLocal } from "slices/local_estimate";
import { setTree } from "slices/project_work";
import { changeRowData as changeRowDataSum } from "slices/summary_estimate";

export const applyColorToEstmTableRow = createAsyncThunk(
	"estimateViewer/applyColorToEstmTableRow",
	async ({ color }, { extra, getState, dispatch }) => {
		const state = getState();
		const currentPage = state.ribbon.currentPage;
		const clickedTableRow = state.ribbon.clickedTableRow;
		const clickedTableCtrlRows = state.ribbon.clickedTableCtrlRows;
		const currentEstmDocId = state.ribbon.currentEstmDocId;

		const projectId = state.projectWork.main.id;
		const summaryHeaderData = state.summaryEstimate.headerData;
		const projectTreeSelected = state.projectWork.treeSelected;
		const projectTree = state.projectWork.tree;

		let colorizeRows = [];
		if (clickedTableCtrlRows) colorizeRows = [...clickedTableCtrlRows];
		if (clickedTableRow) colorizeRows.push(clickedTableRow);

		for (let colorizeRow of colorizeRows) {
			if (currentPage === "LocalEstimateViewer") {
				dispatch(
					changeRowDataLocal({
						rowKey: colorizeRow.key,
						callback: (row) => (row.bgColor = color.hex),
					})
				);
			} else if (currentPage === "KatsEstimateViewer") {
				dispatch(
					changeFiltredRowDataKats({
						rowKey: colorizeRow.key,
						callback: (row) => (row.bgColor = color.hex),
					})
				);
			} else if (currentPage === "SummaryEstimateViewer") {
				dispatch(
					changeRowDataSum({
						rowKey: colorizeRow.key,
						callback: (row) => (row.bgColor = color.hex),
					})
				);
			}
		}

		for (let colorizeRow of colorizeRows) {
			if (currentPage === "LocalEstimateViewer") {
				await extra.apiLocalEstimate.setRowColor({
					project_id: projectId,
					estm_id: currentEstmDocId,
					section_id: colorizeRow.section_id === "" ? null : colorizeRow.section_id,
					item_id: colorizeRow.item_id === "" ? null : colorizeRow.item_id,
					key: colorizeRow.key,
					color: color.hex,
				});
			} else if (currentPage === "KatsEstimateViewer") {
				await extra.apiKatsEstimate.setRowColor({
					project_id: projectId,
					estm_id: currentEstmDocId,
					key: colorizeRow.key,
					color: color.hex,
				});
			} else if (currentPage === "SummaryEstimateViewer") {
				await extra.apiSummaryEstimate.setRowColor({
					project_id: projectId,
					estm_id: summaryHeaderData?.id,
					key: colorizeRow.key,
					color: color.hex,
				});
			}
		}

		if (projectTreeSelected && projectTreeSelected.length > 0 && colorizeRows?.length === 0) {
			const seletedKeys = projectTreeSelected.map((x) => x.key);
			const { editedIterable } = editNestedIterableItem({
				iterable: projectTree,
				isSeekRowCallback: (row) => seletedKeys?.includes(row.key),
				applyCallback: (row) => {
					row.bgColor = color.hex;
				},
			});
			dispatch(setTree(editedIterable));
			await extra.apiProjects.setRowColor({
				project_id: projectId,
				keys: seletedKeys,
				color: color.hex,
			});
		}
	}
);
